var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-subscription-histories"},[_c('h2',[_vm._v("利用ステータス履歴")]),_c('el-row',[_c('el-col')],1),_c('el-row',[_c('el-col',[_c('SubscriptionHistoryList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }